import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'babel-polyfill'

//按需加载
import {
  Layout,
  Content,
  Sider,
  Menu,
  MenuItem,
  Card,
  Icon,
  Tooltip,
  Button,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Modal,
  Message,
  Steps,
  Step,
  Select,
  Option,
  Breadcrumb,
  BreadcrumbItem,
  DatePicker,
  Dropdown,
  DropdownMenu,
  Tabs,
  TabPane,
  RadioGroup,
  Radio
} from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.component("Button", Button);
Vue.component("Layout", Layout);
Vue.component("Content", Content);
Vue.component("Sider", Sider);
Vue.component("Menu", Menu);
Vue.component("MenuItem", MenuItem);
Vue.component("Card", Card);
Vue.component("Icon", Icon);
Vue.component("Tooltip", Tooltip);
Vue.component("Row", Row);
Vue.component("Col", Col);
Vue.component("Form", Form);
Vue.component("FormItem", FormItem);
Vue.component("Input", Input);
Vue.component("i-input", Input);
Vue.component("Steps", Steps);
Vue.component("Step", Step);
Vue.component("Select", Select);
Vue.component("Option", Option);
Vue.component("Modal", Modal);
Vue.component("Breadcrumb", Breadcrumb);
Vue.component("BreadcrumbItem", BreadcrumbItem);
Vue.component("DatePicker", DatePicker);

Vue.component("Dropdown", Dropdown);
Vue.component("DropdownMenu", DropdownMenu);
Vue.component("Tabs", Tabs);
Vue.component("TabPane", TabPane);
Vue.component("RadioGroup", RadioGroup);
Vue.component("Radio", Radio);
Vue.prototype.$Modal = Modal;
Vue.prototype.$Message = Message;

//vue-treeselect
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
Vue.component("Treeselect", Treeselect);

//element-ui
import { Loading, Upload } from 'element-ui';
Vue.use(Loading.directive);
Vue.use(Upload);

import iRegion from '@/assets/region/region.min';
Vue.use(iRegion);
import "@/assets/region/region.css"

//样式重置文件
import './assets/css/reset.css'

//测试环境还是生产环境 标识
// import Setting from "@/setting.env";
Vue.prototype.editionType = (process.env.NODE_ENV == 'test' || process.env.NODE_ENV == 'development');
Vue.prototype.testTxt = process.env.VUE_APP_TITLE;
//图片浏览地址
import Settings from "@/setting";
Vue.prototype.fileUrl = Settings.fileUrl;

// md5机密
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')